'use client';

import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import breakpoints from '@/lib/breakpoints';
import { useMediaQuery } from '@/hooks/useMediaQuery';

import { SocialMediaProps } from '@/models/SocialMedia';

import SocialMediaStatic from './SocialMediaStatic';

export default function ShareButtonsArticleMobile(props: SocialMediaProps) {
  const { socialmedia, share, pageDescription } = props;
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints.lg})`);
  const [desktop, setDesktop]: [boolean, Dispatch<SetStateAction<boolean>>] =
    useState(true);

  useEffect(() => {
    setDesktop(isDesktop);
  }, [isDesktop]);

  if (desktop) return <></>;

  return (
    (socialmedia || share) && (
      <SocialMediaStatic
        socialmedia={socialmedia}
        share={share}
        pageDescription={pageDescription}
      />
    )
  );
}
